import _ from "lodash";
import { getContentFullArray } from "./SimpleArrayOfValues";
import ConditionalLabel from "./ConditionalLabel";

const YesNoOrChildren = ({ label, switchValue, arrayValue, otherValue, children, isChildrenVisible, style, indent }) => {
    const trimmedOtherValue = otherValue?.trim();
    const isValueVisible =
        isChildrenVisible !== undefined
            ? isChildrenVisible
            : (arrayValue && !_.isEmpty(getContentFullArray(arrayValue))) ||
              (trimmedOtherValue !== undefined && trimmedOtherValue !== null);
    return (
        <>
            {!isValueVisible && (
                <ConditionalLabel
                    {...{
                        value: switchValue,
                        noDetails: switchValue && !isValueVisible,
                        label,
                        style,
                        indent
                    }}
                />
            )}
            {isValueVisible && children}
        </>
    );
};

export default YesNoOrChildren;
